(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["july-4th-early-access"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.july4-cat-nav__link').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      var header = document.querySelector('#shopify-section-header')
                || document.querySelector('.site-header')
                || document.querySelector('header');
      var headerH = header ? header.getBoundingClientRect().height : 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerH - 16;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["july-4th-sale"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.july4-cat-nav__link').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      var header = document.querySelector('#shopify-section-header')
                || document.querySelector('.site-header')
                || document.querySelector('header');
      var headerH = header ? header.getBoundingClientRect().height : 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerH - 16;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["memorial-day-early-access"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.mday-cat-nav__link').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      var header = document.querySelector('#shopify-section-header')
                || document.querySelector('.site-header')
                || document.querySelector('header');
      var headerH = header ? header.getBoundingClientRect().height : 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerH - 16;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["memorial-day-sale"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.mday-cat-nav__link').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      var header = document.querySelector('#shopify-section-header')
                || document.querySelector('.site-header')
                || document.querySelector('header');
      var headerH = header ? header.getBoundingClientRect().height : 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerH - 16;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prime-time-early-access"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.prime-ea-page .prime-cat-nav__link').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      var header = document.querySelector('#shopify-section-header')
                || document.querySelector('.site-header')
                || document.querySelector('header');
      var headerH = header ? header.getBoundingClientRect().height : 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerH - 16;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prime-time-final-day"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.prime-fd-page .prime-cat-nav__link').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      var header = document.querySelector('#shopify-section-header')
                || document.querySelector('.site-header')
                || document.querySelector('header');
      var headerH = header ? header.getBoundingClientRect().height : 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerH - 16;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
